const ITEMS = [
  "SPORTS SWEAT",
  "INAUGURAÇÃO",
  "31 DE OUTUBRO DE 2026",
  "A PARTIR DAS 15H",
  "GOIANÉSIA — GOIÁS",
  "ESPERO VOCÊ",
];

export default function Marquee() {
  return (
    <div className="marquee py-4" data-testid="marquee" aria-hidden="true">
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div className="marquee-half" key={half}>
            {ITEMS.concat(ITEMS).map((item, i) => (
              <span
                key={i}
                className="flex items-center text-xs md:text-sm tracking-[0.4em] whitespace-nowrap pr-14"
                style={{ color: "var(--muted)" }}
              >
                {item}
                <span className="gold-text text-base pl-14">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
